import {Row} from 'antd';
import classes from '../Pages.module.css';
import SalaryAdvanceDataFeild from './SalaryAdvanceDataFeild'


const BasicSalaryAdvanceDetails = (props) => {

console.log(props,"props in basic data fields is ");
console.log(props.data)

    const handleChange = (e,param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = e.target.value
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    // const handleDChange = (date, dateString, param) => {

    //     props.setData(data => {
    //         const newdata = [...data['header']['rows']]
    //         newdata[0][param] = dateString
    //         return({
    //             ...data,
    //             header : {
    //                 ...data.header,
    //                 rows: newdata
    //             }
    //         })
    //     })
    // }

    const handleSChange = (val,param) => {
             props.setData(data => {
            const newdata = [...data['header']['rows']]
            console.log(newdata,"this is newdata")
            newdata[0][param] = val
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    
    return(
        <div>
        <p></p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
          
          {!props.create && 
            <SalaryAdvanceDataFeild 
              editMode={props.editMode} 
              lg={4} 
              md={24} 
              handleChange={handleChange} 
              name="ADVANCE_CODE" 
              param="advance_code" 
              value={props.data.advance_code ? props.data.advance_code : null}
            />
          }
          
          <SalaryAdvanceDataFeild 
            editMode={props.editMode} 
            lg={4} 
            md={24} 
            type ="Select"
            handleChange={handleSChange} 
            options={props.ad.EMP_CD}
            name="Employee Name" 
            param="emp_cd" 
            value={props.data.emp_cd ? props.data.emp_cd : null}
            required="True"
          />
          
          
          <SalaryAdvanceDataFeild 
            editMode={props.editMode} 
            lg={4} 
            md={24}
            type ="Select"
            handleChange={handleSChange} 
            options={props.ad.ADV_MONTH}
            name="Advance Month" 
            param="adv_month" 
            value={props.data.adv_month}
            required="True"
          />
          
          <SalaryAdvanceDataFeild 
            editMode={props.editMode} 
            lg={4} 
            md={24} 
            type ="Select"
            handleChange={handleSChange} 
            options={props.ad.ADV_YEAR}
            name="Advance year"
            param="adv_year" 
            value={props.data.adv_year}
            required="True"
          />
          
          <SalaryAdvanceDataFeild 
            editMode={props.editMode} 
            lg={4} 
            md={24} 
            handleChange={handleChange} 
            name="Advance Amount" 
            param="adv_amount" 
            value={props.data.adv_amount ? props.data.adv_amount : null}
            required="True"
          />
          
          <SalaryAdvanceDataFeild 
            editMode={props.editMode} 
            lg={4} 
            md={24} 
            handleChange={handleChange} 
            name="Card No" 
            param="card_no" 
            value={props.data.card_no ? props.data.card_no : null}
          />
        </Row>
      </div>
      
    );
}


export default BasicSalaryAdvanceDetails;
